var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMashreq(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 84.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-11 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-15 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-16 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-17 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-20 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-21 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-22 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-9 {\n        fill: #1b4298;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m496.15,30.16v20.76c0,3.09.42,4.35.42,4.63-.14,0-1.68.84-4.49.84h-10.24c.14-.28.56-2.67-1.12-5.61-2.81-4.91-4.35-8.84-8.28-8.84-4.91,0-6.87,4.77-10.24,10.38-.98,1.54-1.82,4.07-5.89,4.07h-8.42c-.14-.14-.56-.84-.56-1.82,0-6.59-2.67-10.52-5.33-12.48l-3.51,3.51c2.67,1.96,3.93,4.21,3.93,8.28,0,1.82.28,2.24.56,2.52h-6.03c-.14-.42-.42-.98-.42-2.24,0-5.19-2.95-7.57-4.63-9.12l-3.51,3.51c.7.42,3.37,1.96,3.37,5.33,0,1.68.28,2.24.42,2.52h-5.61c-.14-.28-.42-.98-.42-2.24,0-5.19-2.95-7.57-4.63-9.12l-3.37,3.51c.7.56,3.37,2.1,3.37,5.61,0,1.12.28,2.1.42,2.24h-13.33c-.28-4.35-2.52-8-5.05-9.82l-3.65,3.65c2.24,2.38,3.51,5.19,3.51,8.98,0,5.89-3.65,9.54-10.1,10.66l.42,3.37c10.24-.56,14.59-6.31,14.87-11.78h49.38c3.79,0,5.47-1.96,5.89-2.81.42.56,2.38,2.81,7.72,2.81h20.62c5.75,0,9.68-1.68,9.96-1.68-.14-.28-.56-1.54-.56-3.65v-27.07l-5.47,1.1h0Zm-29.88,23.7c2.38-4.21,3.23-6.31,5.33-6.31,1.82,0,2.38,1.82,4.63,5.75.98,1.82,0,3.09-1.26,3.09h-2.1c-4.21,0-5.62-1.69-6.6-2.53"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 512,
    height: 84.44
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -685.01,
    cy: 82.18,
    fx: -685.01,
    fy: 82.18,
    r: 0.58,
    gradientTransform: "translate(38013.18 -4463.15) scale(55.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05133"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -686.71,
    cy: 81.52,
    fx: -686.71,
    fy: 81.52,
    r: 0.58,
    gradientTransform: "translate(44692.74 -5216.78) scale(64.63)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -688.68,
    cy: 80.67,
    fx: -688.68,
    fy: 80.67,
    gradientTransform: "translate(55992.61 -6473.67) scale(80.87)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -690.51,
    cy: 79.86,
    fx: -690.51,
    fy: 79.86,
    r: 0.58,
    gradientTransform: "translate(72779.06 -8330.75) scale(104.98)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: -692.47,
    cy: 79.02,
    fx: -692.47,
    fy: 79.02,
    r: 0.58,
    gradientTransform: "translate(104930.9 -11879.3) scale(151.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f05133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05133"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -693.47,
    cy: 78.58,
    fx: -693.47,
    fy: 78.58,
    r: 0.58,
    gradientTransform: "translate(135264.73 -15224.41) scale(194.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f05133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05133"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m381.55,43.76c-1.54,0-2.24,1.4-2.24,2.24,0,2.38,2.24,2.95,7.15,4.49,0-1.96-2.53-6.73-4.91-6.73m-5.9,17.68h-8.28c-8.7,0-13.33-3.23-13.33-10.52,0-5.33,3.09-10.52,3.51-11.08l4.07,2.1c-.42.98-2.52,4.49-2.52,7.86,0,3.79,2.67,6.59,7.57,6.59h11.78c4.77,0,6.45-1.96,6.59-2.24-5.75-1.12-10.1-1.54-10.1-6.17,0-3.93,4.07-9.4,8-9.4,3.37,0,5.05,2.81,6.03,4.49,1.96,3.23,2.1,5.05,2.1,6.59,0,5.32-3.77,11.78-15.42,11.78"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "389.68 32.26 386.17 28.75 382.81 32.12 379.44 28.75 375.93 32.4 379.44 35.91 382.81 32.54 386.31 35.91 389.68 32.26"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "512 61.44 506.81 61.44 506.81 30.16 512 29.03 512 61.44"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m474.97,56.39h-2.1c-4.21,0-5.75-1.68-6.59-2.52,2.38-4.21,3.23-6.31,5.33-6.31,1.82,0,2.52,1.82,4.63,5.75,1.11,1.67.13,3.08-1.27,3.08m26.23-.28v-27.07l-5.19,1.26v20.76c0,3.09.42,4.35.42,4.63-.14,0-1.68.84-4.49.84h-10.1c.14-.28.56-2.52-1.12-5.61-2.81-4.91-4.35-8.84-8.28-8.84-4.91,0-6.87,4.77-10.24,10.38-.98,1.54-1.82,4.07-5.89,4.07h-8.42c-.14-.14-.56-.84-.56-1.82,0-6.59-2.67-10.52-5.33-12.48l-3.51,3.51c2.67,1.96,3.93,4.21,3.93,8.28,0,1.82.28,2.24.56,2.52h-6.03c-.14-.42-.42-.98-.42-2.24,0-5.19-2.95-7.57-4.63-9.12l-3.51,3.51c.7.42,3.37,1.96,3.37,5.33,0,1.68.28,2.24.42,2.52h-5.61c-.14-.28-.42-.98-.42-2.24,0-5.19-2.95-7.57-4.63-9.12l-3.37,3.51c.7.56,3.37,2.1,3.37,5.61,0,1.12.28,2.1.42,2.24h-13.33c-.28-4.35-2.52-8-5.05-9.82l-3.65,3.65c2.24,2.38,3.51,5.19,3.51,8.98,0,5.89-3.65,9.54-10.1,10.66l.42,3.37c10.24-.56,14.59-6.31,14.87-11.78h49.38c3.79,0,5.47-1.96,5.89-2.67.42.56,2.38,2.67,7.72,2.67h20.62c5.75,0,9.68-1.68,9.96-1.68-.42-.45-.98-1.85-.98-3.81"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m471.74,47.55c-2.1,0-2.95,2.1-5.33,6.31.84.84,2.38,2.52,6.59,2.52h2.1c1.26,0,2.24-1.26,1.26-3.09-2.23-3.92-2.94-5.74-4.62-5.74"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "437.94 34.36 434.43 30.86 431.06 34.22 427.7 30.86 424.19 34.5 427.7 38.01 431.06 34.65 434.57 38.01 437.94 34.36"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "434.57 28.61 430.92 25.11 427.56 28.75 431.06 32.26 434.57 28.61"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m124.14,43.76c-3.09,0-4.35,2.38-4.35,4.77h8.84c0-2.66-1.54-4.77-4.49-4.77m9.54,8.84h-13.89c.28,2.81,2.52,4.91,5.89,4.91,2.95,0,4.91-1.26,5.19-1.4l1.82,3.93c-.42.14-3.09,1.96-7.57,1.96-6.59,0-10.8-4.49-10.8-11.22,0-6.17,3.23-11.22,9.96-11.22,6.17,0,9.82,4.35,9.82,10.24-.14,1.12-.42,2.38-.42,2.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m47.83,54.56v-3.65c-.7.56-2.52.98-4.07,1.4-1.82.42-3.65,1.12-3.65,2.67,0,1.96,1.96,2.67,3.93,2.67,2.1,0,3.79-.56,3.93-.7,0-.14-.14-.84-.14-2.39m-3.64,7.44c-4.63,0-9.68-1.68-9.68-6.73,0-5.89,6.31-6.31,10.24-7.15,1.82-.42,3.09-.98,3.09-2.24,0-1.12-1.4-1.96-3.65-1.96-2.95,0-5.75,1.26-6.03,1.4l-1.68-3.93c.42-.14,4.07-1.82,8-1.82,5.33,0,8.42,2.81,8.42,7.86v9.4c0,2.24.28,3.09.42,3.51-.3-.02-4.64,1.66-9.13,1.66"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m90.34,61.44v-13.47c0-2.52-1.4-4.07-3.93-4.07-1.96,0-3.79,1.12-4.63,1.54v15.85h-5.19v-31.27l5.19-1.26v12.2c.28-.14,2.67-1.68,6.03-1.68,4.91,0,7.72,2.95,7.72,7.57v14.31h-5.19v.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m148.41,43.9c-4.07,0-5.61,3.09-5.61,6.73s2.1,6.73,6.03,6.73c.98,0,1.96-.28,2.81-.56v-9.68c0-1.4.14-2.52.14-2.67-.14,0-1.41-.55-3.37-.55m8.28.99v25.67l-5.19.7v-9.96c-1.26.42-2.67.7-3.93.7-5.75,0-10.66-4.63-10.66-11.22s4.49-11.22,11.5-11.22c3.93,0,7.86,1.4,8.42,1.54,0,.42-.14,2.24-.14,3.79"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m25.53,61.44v-13.47c0-2.38-1.26-3.93-3.79-3.93-1.82,0-3.65.98-3.93,1.12,0,.28.28,1.4.28,3.23v13.05h-5.19v-13.61c0-2.38-1.26-3.93-3.79-3.93-1.96,0-3.65.84-3.79.98,0,.14.14.84.14,2.1v14.45H.28v-16.97c0-1.26-.28-2.52-.42-2.81.56-.14,5.47-2.24,9.68-2.24,4.49,0,6.03,1.82,6.31,2.1.28-.28,3.37-2.1,6.73-2.1,4.77,0,8,2.81,8,7.43v14.59h-5.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m112.22,44.46c-.7-.14-1.82-.42-2.81-.42-2.1,0-3.93.56-4.07.56,0,.14.28,1.12.28,2.95v14.03h-5.19v-15.43c0-2.52-.42-4.07-.42-4.21.56-.28,5.19-2.38,9.82-2.38,1.4,0,2.81.14,3.93.42l-1.54,4.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m64.25,62c-3.65,0-6.73-1.26-7.15-1.4l1.54-4.07c.14,0,2.38,1.26,4.63,1.26,2.52,0,3.79-.98,3.79-2.38,0-.98-.7-1.96-2.38-2.52-.56-.28-1.54-.56-2.1-.84-2.24-.84-4.77-2.38-4.77-5.89,0-4.21,3.93-6.45,7.86-6.45,3.51,0,5.75,1.12,6.31,1.26l-1.4,3.93c-.14,0-2.38-.98-4.77-.98-1.4,0-2.67.56-2.67,1.82s.84,1.82,2.38,2.38c.56.28,1.54.56,2.24.84,2.81,1.12,5.19,2.81,5.19,6.31-.15,4.62-4.22,6.73-8.7,6.73"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m326.14,46.29c-5.33,2.81-8.28,7.57-10.38,12.91,5.61,1.26,11.22,1.54,16.55-1.26,5.33-2.81,8.28-7.57,10.38-12.91-2.38-.56-4.91-.98-7.29-.98-3.23.13-6.32.69-9.26,2.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m312.25,32.54c-4.63,7.29-4.63,14.17-3.65,19.78,5.47-1.68,11.64-4.49,16.27-11.92,4.63-7.29,4.49-14.17,3.65-19.78-5.47,1.68-11.64,4.63-16.27,11.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m289.81,27.63c-.14,9.68,4.07,17.39,8.14,22.86,4.21-5.47,8.7-12.91,8.84-22.58.14-10.52-4.91-18.38-8.14-22.86-3.51,4.49-8.7,12.06-8.84,22.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m263.43,31.56c5.89,10.94,14.87,16.97,23.29,21.88.7-9.68.28-20.76-5.47-31.56-6.31-11.78-16.55-18.1-23.29-21.88-.42,7.85-.98,19.5,5.47,31.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m207.04,20.2c5.33,9.12,15.43,22.58,30.44,31.14,14.45,8.14,30.72,10.24,42.36,10.1-6.17-10.24-15.99-23-30.44-31.14-14.17-8-30.44-10.1-41.38-10.1h-.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m166.79,71.54c16.55,7.43,36.19,12.91,54.85,12.91,14.87,0,32.82-2.95,54.85-12.91-24.13-10.8-40.96-12.91-54.85-12.91-18.1-.14-38.58,5.33-54.85,12.91"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMashreq);
export default __webpack_public_path__ + "static/media/mashreq.811eed55799ba5b77c48abc7d864c5a3.svg";
export { ForwardRef as ReactComponent };